import { render, staticRenderFns } from "./DatasourceView.vue?vue&type=template&id=6f4bff2e&"
import script from "./DatasourceView.vue?vue&type=script&lang=js&"
export * from "./DatasourceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f4bff2e')) {
      api.createRecord('6f4bff2e', component.options)
    } else {
      api.reload('6f4bff2e', component.options)
    }
    module.hot.accept("./DatasourceView.vue?vue&type=template&id=6f4bff2e&", function () {
      api.rerender('6f4bff2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/DatasourceView.vue"
export default component.exports